// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../fetch.pb.js";
export const FormsAPI = {
    /**
     * calls to Weave from the Forms app we need to handle
     * See TPD at https://docs.google.com/document/d/18Dp-HMbPae80SL0aDpUlcWsMXzdG2W98yYON3khPaAk/edit#
     * This will have the updated local and remote API spec
     *
     * Deprecated: Use weave-digital-forms service instead
     */
    PacketList(fn, req) {
        return fn(`/forms/v1/packets?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Deprecated: Use weave-digital-forms service instead
     */
    FormList(fn, req) {
        return fn(`/forms/v1/forms?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    FormLinks(fn, req) {
        return fn(`/forms/v1/links`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetSubmissionConfirmation(fn, req) {
        return fn(`/forms/v1/confirmation?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    SetSubmissionConfirmation(fn, _req) {
        return fn(`/forms/v1/confirmation`, { method: "PATCH" });
    },
    /**
     * Gets list of companies requiring a reminder for uploaded forms digitization
     */
    GetCompaniesForUploadReminder(fn, req) {
        return fn(`/forms/v1/companies-for-upload-reminder?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Returns true if user can access forms upload page
     */
    CanUploadForms(fn, req) {
        return fn(`/forms/v1/can-upload-forms?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * This API is used to fetch all the form digitization process details
     */
    GetUploadedFormsDetails(fn, req) {
        return fn(`/forms/v1/digitization?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
